import { postWithAuth } from '@/lib/httpAdapter';
import Repository from '@/types/repositoryType';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;
const endPoint = 'fetchUserRepos/';
const url = localHost + endPoint;

const fetchUserRepos = async (UserUUID: string, headerObj: headerObject) => {
  try {
    const res = await postWithAuth(
      url,
      {
        UserUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    const repos = data.Repositories.filter(
      (repo: Repository) => repo.OrganizationID === ''
    );
    return repos;
  } catch (err) {
    console.error(err);
  }
};

export default fetchUserRepos;
